__turbopack_context__.v({
  "link": "Link-module-scss-module__wKC3Aq__link",
});
